import cn from 'classnames';

import useIsScreenSize from 'js/hooks/use-is-screen-size';

import Heading from 'components/heading/Heading';
import Table from 'components/table/Table';
import RichText from 'components/rich-text/RichText';
import TableMobile from 'components/table-mobile/TableMobile';

import { ITableBlock } from 'source/NFR.types';

interface ITableBlockProps extends ITableBlock {
  isWide?: boolean;
}

const TableBlock: React.FC<ITableBlockProps> = ({ table, mobileList, title, richText, isWide }) => {
  const isMobile = useIsScreenSize('mdMax');

  return (
    <div className={cn('table-block', { 'table-block--wide': isWide })}>
      {!isMobile ? (
        <Table {...table} title={title} />
      ) : (
        <>
          {mobileList ? (
            <>
              {title && <Heading className="table--title">{title}</Heading>}

              <TableMobile {...mobileList} />
            </>
          ) : (
            <Table {...table} title={title} />
          )}
        </>
      )}
      {richText && <RichText {...richText} />}
    </div>
  );
};

TableBlock.displayName = 'TableBlock';

export default TableBlock;
